'use strict';
// B.2.3.3 String.prototype.big()
require('./_string-html')('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/polyfill/node_modules/core-js/modules/es6.string.big.js
// module id = 222
// module chunks = 0